export enum ResourceType {
  ORDERS = 'orders',
  ATTACHMENTS = 'attachments',
  INVOICES = 'invoices',
  CUSTOMERS = 'customers',
  MACHINES = 'machines'
}
